export enum AdressesLabel {
  HOME = 'home',
  WORK = 'work',
  OTHERS = 'other',
}
export interface IAddresses {
  _id: string;
  title: string;
  location: {
    lon: number;
    lat: number;
  };
  details: {
    entrance: string;
    intercom: string;
    floor: string;
    apartment: string;
    comment: string;
  };
  label_type?: AdressesLabel;
  label_value?: string;
}
export interface IAddressesRespone {
  id: string;
  client_id: string;
  title: string;
  geo: string;
  type: string | null;
  detail: string | null;
  status: string | null;
  orientir: string | null;
}

export interface IAddressDetail {
  dom?: string;
  kv?: string;
  dop_nomer?: string;
  kod?: string;
  comment?: string;
}
export interface ICreateAddress {
  title: string;
  geo: string;
  dom?: string;
  kv?: string;
  dop_nomer?: string;
  kod?: string;
  comment?: string;
  type: string;
}
